import { ButtonBase, Tooltip } from '@material-ui/core';
import { Done, FileCopy } from '@material-ui/icons';
import { ColorDynamic } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { ReactElement, useCallback } from 'react';
import { useClipboard } from 'shared/helpers/DomHelpers';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

interface CopyToClipboardTooltipProps {
  children: ReactElement;
  textToCopy: string;
  title: string;
  onCopy?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function CopyToClipboardTooltip({
  children,
  textToCopy,
  title,
  onCopy,
}: CopyToClipboardTooltipProps) {
  const { copy, status, reset } = useClipboard();

  const handleClose = useCallback(() => {
    // Reset copy status after tooltip is closed, there was issue with resetting status before tooltip is closed
    setTimeout(reset, 200);
  }, [reset]);

  const handleCopy = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (textToCopy && status !== 'copied') {
        copy(textToCopy);
        onCopy?.(event);
      }
    },
    [copy, onCopy, status, textToCopy],
  );

  return (
    <Tooltip
      interactive={true}
      onClose={handleClose}
      placement="top"
      title={
        textToCopy && (
          <ButtonBase disableRipple={true} onClick={handleCopy}>
            <Container>
              {status === 'copied' ? (
                <>
                  <Done htmlColor={ColorDynamic.White} fontSize="small" />
                  <TextBox color="white">Copied</TextBox>
                </>
              ) : (
                <>
                  <FileCopy htmlColor={ColorDynamic.White} fontSize="small" />
                  <TextBox color="white" align="left">
                    {title || 'Copy'}
                  </TextBox>
                </>
              )}
            </Container>
          </ButtonBase>
        )
      }
    >
      {children}
    </Tooltip>
  );
}
